/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import Subject from '../../rx/Subject';
import {DecodedFrameTimingInformation, RenderedFrameTimingInformation} from '../frameTiming/FrameTimingInformation';

export default class FrameTimingInformationContext {
  public readonly shouldExtractTimecode: Subject<boolean>;
  public readonly shouldExtractTimestamps: Subject<boolean>;
  public readonly isEnabled: Subject<boolean>;
  public readonly decodedFrameTimingInformation: Subject<DecodedFrameTimingInformation | null>;
  public readonly renderedFrameTimingInformation: Subject<RenderedFrameTimingInformation | null>;

  constructor() {
    this.shouldExtractTimecode = new Subject<boolean>(false);
    this.shouldExtractTimestamps = new Subject<boolean>(false);
    this.isEnabled = new Subject<boolean>(false);
    this.decodedFrameTimingInformation = new Subject<DecodedFrameTimingInformation | null>(null);
    this.renderedFrameTimingInformation = new Subject<RenderedFrameTimingInformation | null>(null);
  }
}